import { render, staticRenderFns } from "./commodityAll.vue?vue&type=template&id=64e67900&scoped=true&"
import script from "./commodityAll.vue?vue&type=script&lang=js&"
export * from "./commodityAll.vue?vue&type=script&lang=js&"
import style0 from "./commodityAll.vue?vue&type=style&index=0&id=64e67900&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e67900",
  null
  
)

export default component.exports